module.exports = __webpack_public_path__ + "static/services_ma.b6a23779.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pageheaders/services_ma.jpg
// module id = 610
// module chunks = 1567898479519